export const headerFormStyle = {
	wrapper: {
		display: 'flex',
		justifyContent: 'center',
		flexDirection: 'column',
		textAlign: 'center',
		marginBottom: '24px',
	} as any,

	logo: {
		margin: '0 auto',
		paddingBottom: '40px',
	},

	title: {
		fontSize: '24px',
		color: 'var(--primary-700)',
		fontWeight: '700',
	},

	description: {
		marginTop: '4px',

		color: 'var(--neutral-300)',
	},
};
